import React from 'react';
import _ from 'lodash';
import { Col, Row } from 'grab-ui';
import PerformancePanel from 'omega-rtc/views/ucd/trident/common/PerformancePanel';
import { RATE_NAME_DISPLAY, SCORE_CATEGORY } from 'omega-rtc/constants/metrics';
import { BenchmarkMap, CommsMetricsMap } from 'omega-rtc/types/trident-campaigns';
import { METRICS_FIELD_MAPPING } from 'omega-rtc/constants/ucd';
import { isPushChannel } from 'omega-rtc/views/trident-campaigns/metrics/utils';

type Props = {
  metricsStat: CommsMetricsMap, // Map of channel name to metrics. {"Email": {attempted:620, click:100, ...}, ...}
  metricsBenchmark: BenchmarkMap,
};

const PERFORMANCE_SUMMARY_RATES = ['openRate', 'clickThroughRate'];

export class PerformanceSummarySection extends React.Component {
  props: Props;

  constructChannelToRatesMap(metricsStat: CommsMetricsMap) {
    const channelToRatesMap = {};
    _.forEach(metricsStat, (stats, channel) => {
      const open = _.get(stats, METRICS_FIELD_MAPPING.default.open, 0);
      const delivered = _.get(stats, METRICS_FIELD_MAPPING.default.delivered, 0);
      const sent = _.get(stats, METRICS_FIELD_MAPPING.default.sent, 0);
      const click = _.get(stats, METRICS_FIELD_MAPPING.default.click, 0);

      const openRateDivider = isPushChannel(channel) ? sent : delivered;
      channelToRatesMap[channel] = {
        openRate: (open * 100) / openRateDivider,
        clickThroughRate: open === 0 ?
          0
          : (click * 100) / open,
      };
    });
    return channelToRatesMap;
  }


  render() {
    const { metricsStat, metricsBenchmark } = this.props;

    const channelToRatesMap = this.constructChannelToRatesMap(metricsStat);

    const greatPerformanceMetrics = [];
    const goodPerformanceMetrics = [];
    const badPerformanceMetrics = [];

    _.forEach(channelToRatesMap, (rates, channel) => {
      const percentile90Rates = _.get(metricsBenchmark, 'percentile90', {});
      const averageRates = _.get(metricsBenchmark, 'average', {});

      PERFORMANCE_SUMMARY_RATES.forEach((rateType) => {
        if (rateType === 'clickThroughRate' && isPushChannel(channel)) {
          return; // Excluded as push comms doesn't have click attribute
        }

        const channelRate = _.get(rates, rateType, 0).toFixed(2);
        const rateName = RATE_NAME_DISPLAY[rateType];
        const benchmarkPercentile90Rate = _.get(percentile90Rates, `${channel}.${rateType}`, 0);
        const benchmarkAverageRate = _.get(averageRates, `${channel}.${rateType}`, 0);

        if (benchmarkPercentile90Rate !== 0 && channelRate > benchmarkPercentile90Rate) {
          const upliftPercentage = channelRate - benchmarkPercentile90Rate;
          greatPerformanceMetrics.push({ channel, rateName, upliftPercentage });
          return;
        }

        if (benchmarkAverageRate !== 0) {
          if (channelRate > benchmarkAverageRate) {
            const upliftPercentage = channelRate - benchmarkPercentile90Rate;
            goodPerformanceMetrics.push({ channel, rateName, upliftPercentage });
          } else {
            const upliftPercentage = channelRate - benchmarkAverageRate;
            badPerformanceMetrics.push({ channel, rateName, upliftPercentage });
          }
        }
      });
    });

    let numOfTopMetrics = 2;
    let columnWidth = 12;
    if (greatPerformanceMetrics.length > 0 && goodPerformanceMetrics.length > 0 && badPerformanceMetrics.length > 0) {
      numOfTopMetrics = 1;
      columnWidth = 8;
    }

    return (
      <Row style={{ marginTop: 0, padding: 0, width: 'calc(100% + 30px)', marginLeft: -15, marginBottom: 10 }}>
        {greatPerformanceMetrics.length > 0 &&
          <Col span={columnWidth} style={{ padding: '0 15px' }}>
            <PerformancePanel
              numOfTopMetrics={numOfTopMetrics}
              scoreCategory={SCORE_CATEGORY.great}
              metricsPerformanceList={greatPerformanceMetrics}
            />
          </Col>
        }
        {goodPerformanceMetrics.length > 0 &&
          <Col span={columnWidth} style={{ padding: '0 15px' }}>
            <PerformancePanel
              numOfTopMetrics={numOfTopMetrics}
              scoreCategory={SCORE_CATEGORY.good}
              metricsPerformanceList={goodPerformanceMetrics}
            />
          </Col>
        }
        {
          badPerformanceMetrics.length > 0 &&
          <Col span={columnWidth} style={{ padding: '0 15px' }}>
            <PerformancePanel
              numOfTopMetrics={numOfTopMetrics}
              scoreCategory={SCORE_CATEGORY.bad}
              metricsPerformanceList={badPerformanceMetrics}
            />
          </Col>
        }
      </Row>

    );
  }
}

export default PerformanceSummarySection;
